<div class="current-region-container">
  <app-multi-select
    [options]="_countries"
    [initialMultiData]="_selected_countries"
    [isMultiselector]="isMultiSelect"
    [showSelectAll]="true"
    [placeholder]="'Select an country'"
    [entity]="'countries'"
    (valueChange)="handleCountryChange($event)"
    (closedWithChanges)="handleMultiSelectClosedWithChanges($event)"
  ></app-multi-select>
</div>
